<template>
  <div>
    <!-- 银行账号变更弹窗 -->
    <el-dialog
      title="银行账号变更"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          class="demo-cityForm"
          label-width="200px"
          ref="refCityForm"
          v-loading="dialogLoading"
          :model="cityForm"
          :rules="cityRules"
        >
          <div class="font-15 font-weight mb-10">供应商: {{ title }}</div>

          <template>
            <el-form-item label="主体性质" prop="certification_type">
              <el-radio-group
                v-model="cityForm.certification_type"
                :disabled="true"
              >
                <el-radio :label="10">个人</el-radio>
                <el-radio :label="20">个体工商户</el-radio>
                <el-radio :label="30">企业</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 企业个体工商户 -->
    <div v-if="(cityForm.certification_type==20 ||cityForm.certification_type==30)&&cityForm.account_type==30">


        <el-form-item label="营业执照" prop="license_img">
              <el-upload
                :disabled="true"
                :action="httpurl"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: license_img.length || !license_img }"
                :file-list="license_img"
                :headers="{ token: token }"
                list-type="picture-card"
                :on-success="onsuccess"
                :before-remove="() => onHandleDeleteFile('license_img')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="统一社会信息码" prop="uscc">
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.uscc"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              label="企业名称"
              
            >
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.company_name"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              
              label="企业联系电话"
              prop="company_mobile"
              v-if="cityForm.certification_type == 30"
            >
              <div>
                <el-input
                :disabled="true"
                  v-model="cityForm.company_mobile"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="绑卡类型" prop="account_type">
              <el-radio-group :disabled="true" v-model="cityForm.account_type">
                <el-radio :label="10">个人</el-radio>

                <el-radio :label="30">企业</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="持卡人身份证国徽页图片" prop="idcard_a">
              <el-upload
                action="#"
                :disabled="true"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_a.length || !idcard_a }"
                :file-list="idcard_a"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_a')"
                :before-remove="() => onHandleDeleteFile('idcard_a')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="持卡人身份证人像页图片" prop="idcard_b">
              <el-upload
                action="#"
                :disabled="true"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_b.length || !idcard_b }"
                :file-list="idcard_b"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_b')"
                :before-remove="() => onHandleDeleteFile('idcard_b')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="
             法人姓名
            "
            >
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.idcard_name"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              label="
            
             法人身份证号
               
            "
            >
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.idcard_code"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="
               法人手机号码
            "
            >
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.manage_mobile"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>



    </div>
      <!-- 企业个体工商户 -->
       <!-- 个人 -->
          <div v-if="(cityForm.certification_type==10||cityForm.certification_type==20)&&cityForm.account_type==10">


        <el-form-item label="营业执照" prop="license_img">
              <el-upload
                :disabled="true"
                :action="httpurl"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: license_img.length || !license_img }"
                :file-list="license_img"
                :headers="{ token: token }"
                list-type="picture-card"
                :on-success="onsuccess"
                :before-remove="() => onHandleDeleteFile('license_img')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="统一社会信息码" prop="uscc">
              <div>
                <el-input
                  :disabled="true"
                  v-model="cityForm.uscc"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
          
            <el-form-item label="绑卡类型" prop="account_type">
              <el-radio-group :disabled="true" v-model="cityForm.account_type">
                <el-radio :label="10">个人</el-radio>

                <el-radio :label="30">企业</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="持卡人身份证国徽页图片" prop="idcard_a">
              <el-upload
                action="#"
              
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_a.length || !idcard_a }"
                :file-list="idcard_a"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_a')"
                :before-remove="() => onHandleDeleteFile('idcard_a')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="持卡人身份证人像页图片" prop="idcard_b">
              <el-upload
                action="#"
              
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_b.length || !idcard_b }"
                :file-list="idcard_b"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_b')"
                :before-remove="() => onHandleDeleteFile('idcard_b')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            
            <el-form-item label="持卡人身份证号" prop="idcard_code">
              <div>
                <el-input
                  v-model="cityForm.idcard_code"
                  placeholder="请输入持卡人身份证号"
                ></el-input>
              </div>
            </el-form-item> 

            



    </div>
       <!-- 个人 -->
            

          

            <el-form-item label="持卡人姓名" prop="company_name"   v-if="cityForm.account_type == 30">
              <div>
                <el-input
                  v-model="cityForm.company_name"
                  placeholder="请输入持卡人姓名"
                  :disabled="true"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="持卡人姓名" prop="username"   v-else>
              <div>
                <el-input
                  v-model="cityForm.username"
                  placeholder="请输入持卡人姓名"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="提现银行卡" prop="card_code">
              <div>
                <el-input
                  v-model="cityForm.card_code"
                  placeholder="请输入提现银行卡"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="所属银行" prop="bank_code">
              <div>
                <el-select
                  @change="
                    depositList = [];
                    cityForm.bank_deposit = '';
                  "
                  v-model="cityForm.bank_code"
                  clearable
                  filterable
                  placeholder="选择所属银行"
                >
                  <el-option
                    @click.native="cityForm.bank_name = item.bank_name"
                    v-for="item in bankList"
                    :key="item.bank_code"
                    :label="item.bank_name"
                    :value="item.bank_code"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="开户行" prop="bank_deposit">
              <div>
                <el-select
                  :remote-method="ajaxGetBranchList"
                  :loading="depositLoading"
                  v-model="cityForm.bank_deposit"
                  clearable
                  filterable
                  remote
                  placeholder="选择开户行"
                >
                  <el-option
                    @click.native="cityForm.deposit_code = item.code"
                    v-for="item in depositList"
                    :key="item.code"
                    :label="item.branch_name"
                    :value="item.branch_name"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
<el-form-item label="银行预留电话" prop="bank_mobile"  v-if="cityForm.certification_type == 10">
              <div>
                <el-input
                  v-model="cityForm.bank_mobile"
                  placeholder="请输入预留电话"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="变更协议" prop="pact_url">
              <el-upload
                action="#"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: pact_url.length || !pact_url }"
                :file-list="pact_url"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'pact_url')"
                :before-remove="() => onHandleDeleteFile('pact_url')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="onHandleSubmit"
          >提交申请</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { postUpdateSupplierBank } from "@/api/generalControl/index.js";
import {

  postGetIdcardInfo,

} from "@/api/general/manager.js";

export default {
  name: "bank-account-change",
  props: {
    /**
     * 银行列表
     */
    bankList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
       token: sessionStorage.getItem("token"),
        httpurl: process.env.VUE_APP_GENERAL_URL + "/uploadBusinessLicense",
      dialogVisible: false,
      dialogLoading: false,
      title: "", // 供应商名称
      loadImage: null,
      depositLoading: false,
      depositList: [], // 开户行列表
      idcard_a: [], // 身份证国徽图片
      idcard_b: [], // 身份证人像图片
      pact_url: [], // 变更协议
      // 城市仓参数
      cityForm: {
        supplier_id: "",
        card_code: "", //提现银行卡
        bank_code: "", // 所属银行code
        bank_name: "", // 所属银行名称
        bank_deposit: "", // 开户行
        deposit_code: "", // 开户行code
        username: "", // 持卡人
        idcard_a: "", // 身份证国徽页
        idcard_b: "", // 身份证人像图片
        idcard_code: "", // 持卡人身份证号
        bank_mobile: "", //预留电话
        pact_url: "",
      },
      cityFormClone: {}, // 拷贝一份数据，用于初始化
      license_img: [],
      logisticsBusinessId: "", // 城市仓id
      uploadLoading: false, // 上传loading
      submitLoading: false, // 提交按钮禁用

      // 表单校验
      cityRules: {
        card_code: [
          {
            required: true,
            message: "请输入提现银行卡",
            trigger: ["blur", "change"],
          },
        ],
        bank_code: [
          {
            required: true,
            message: "请选择所属银行",
            trigger: ["blur", "change"],
          },
        ],
        bank_deposit: [
          {
            required: true,
            message: "请输入开户行",
            trigger: ["blur", "change"],
          },
        ],
        username: [
          {
            required: true,
            message: "请输入持卡人",
            trigger: ["blur", "change"],
          },
        ],
        bank_mobile: [
          {
            required: true,
            message: "请输入预留电话",
            trigger: ["blur", "change"],
          },
          // 正则判断为字母或数字
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],
        idcard_a: [
          {
            required: true,
            message: "请上传身份证国徽页图片",
            trigger: ["blur", "change"],
          },
        ],
        idcard_b: [
          {
            required: true,
            message: "请上传身份证人像页图片",
            trigger: ["blur", "change"],
          },
        ],
        idcard_code: [
          {
            required: true,
            message: "请输入持卡人身份证号",
            trigger: ["blur", "change"],
          },
        ],
        pact_url: [
          {
            required: true,
            message: "请上传变更协议",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
        onsuccess(res) {
      console.log(res, "11111");
     
    },
    /**
     * 初始化
     */
    onInitData(data) {
      console.log(data, "data===");
      this.dialogVisible = true;
      this.idcard_a = [];
      this.idcard_b = [];
      this.pact_url = [];
      this.cityFormClone = cloneDeep(this.cityForm);
      this.$refs.refCityForm?.clearValidate();
      this.license_img = data.license ? [{ url: data.license.img }] : [];
      this.title = data.title; // 供应商名称
      let baseParams = {
        ...data,
        card_code: data.supplier_bank ? data.supplier_bank.card_code : "",
        bank_code: data.supplier_bank ? data.supplier_bank.bank_code : "",
        bank_name: data.supplier_bank ? data.supplier_bank.bank_name : "",
        deposit_code: data.supplier_bank ? data.supplier_bank.deposit_code : "",
        bank_deposit: data.supplier_bank ? data.supplier_bank.bank_deposit : "",
        account_type: data.supplier_bank ? data.supplier_bank.account_type : "",
        username: data.supplier_bank ? data.supplier_bank.username : "",
        idcard_a: data.idcard_a,
        idcard_b: data.idcard_b,
        idcard_code: data.idcard_code,
        bank_mobile: data.supplier_bank ? data.supplier_bank.mobile : "",
        supplier_id: data.id,
        license_img: data.license ? data.license.img : "",
      };

      
      // Object.keys(this.cityForm).forEach((_KEY) => {
      //   this.cityForm[_KEY] = baseParams[_KEY];
      // });
      this.cityForm = baseParams;
      this.idcard_a =
        (data?.idcard_a && [
          {
            url: data.idcard_a,
          },
        ]) ||
        [];
      this.idcard_b =
        (data?.idcard_b && [
          {
            url: data.idcard_b,
          },
        ]) ||
        [];
      this.cityForm.pact_url = "";
      console.log(this.cityForm, "this.cityForm==");
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.cityForm = {
        ...this.cityFormClone,
      };
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },
    /**
     * 获得开户行列表
     */
    async ajaxGetBranchList(query) {
      this.depositList = [];
      if (!query) {
        return;
      }
      this.depositLoading = true;
      const params = {
        bank_code: this.cityForm.bank_code,
        branch_name: query,
      };
      try {
        const { data } = await this.$api.general.branchList(params);
        this.depositList = data;
      } catch (err) {
        console.log("ajax branchList err", err);
      } finally {
        this.depositLoading = false;
      }
    },
    /**
     * 删除图片
     */
    onHandleDeleteFile(name) {
      this[name] = [];
      this.cityForm[name] = "";
      this.$refs.refCityForm.validateField(name);
    },
    /**
     * 上传图片
     */
    onHandleUploadFile(options, name) {
      this.uploadLoading = true;
      // 拿到 file
      let file = options.file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // console.log(e.target.result);
        this.ajaxUploadImage(e.target.result, name, options.file.uid);
      };
    },
    /**
     * 图片路径请求
     */
    async ajaxUploadImage(img, name, uid) {
      try {
        const res = await this.$api.general.uploadImage({ file_data: img });
        // 增加uid 赋值 解决上传图片跳动问题
        this[name] = [{ url: res.data, uid }];
        this.cityForm[name] = res.data;


          if (name == "idcard_b") {
          this.postAjaxGetIdcardInfo(res.data); // 人像页ocr 识别
        }
        this.$refs.refCityForm.validateField(name);
      } catch (err) {
      } finally {
        this.uploadLoading = false;
      }
    },
            // 身份证人像页上传ocr 识别身份证号
    async postAjaxGetIdcardInfo(url) {
      try {
        const res = await postGetIdcardInfo({ image_url: url });
        this.cityForm.idcard_code = res.data.idcard_code;
        this.cityForm.username = res.data.idcard_name;
        console.log(res, res.data.idcard_code, this.addForm, "res==");
      } catch (error) {
        console.log(error, "postGetIdcardInfo");
      }
    },
    /**
     * 预览上传图片
     */
    onHandlePictureCardPreview(file) {
      const params = {
        bigImage: file.url,
        showImage: true,
      };
      this.$emit("on-show-image", params);
    },

    /**
     * 确认
     */
    onHandleSubmit() {
      console.log(this.cityForm, "this.cityForm==");
      this.$refs.refCityForm.validate(async (valid) => {
        console.log(valid, "1valid11");
        if (!valid) {
          return;
        }

        this.submitLoading = true;
        try {
          const res = await postUpdateSupplierBank(this.cityForm);
          console.log(res, "res==");

          this.dialogVisible = false;
          this.$message({
            message: "账号变更成功",
            type: "success",
          });
          this.$emit("on-refresh-list");
        } catch (error) {
          console.log(error, "postUpdateSupplierBank");
        } finally {
          this.submitLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hide {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>
